import ProxyServerConnector from './connectors/ProxyServerConnector';
import { ResponseModel } from './connectors/ResponseModel';

export type RenditionConfiguration = {
    id: number;
    name: string;
    displayName: string;
    type: 'IMAGE' | 'VIDEO' | 'PDF';
    tool: 'FFMPEG' | 'NUKE';
    parameters: string;
    extension: string;
    dynamic: boolean;
    disabled: null;
    containerType: null;
    downloadable: boolean;
    displayOrder: null | number;
    targets: string[];
};

class RenditionsService extends ProxyServerConnector {
    gateway: ProxyServerConnector;

    constructor(path = '/renditions') {
        super(path);
        this.gateway = new ProxyServerConnector('/', GATEWAY_PREFIX);
    }

    getRenditionConfigurations(
        customerId: number,
        creativeType: 'IMAGE' | 'VIDEO',
    ): Promise<ResponseModel<RenditionConfiguration[]>> {
        return this.gateway.get(`customer/${customerId}/rendition-configurations?creativeType=${creativeType}`);
    }
}

export default new RenditionsService();
